export default __webpack_public_path__ + "static/media/audio_49_agua_hirviendo.40735787.mp3";